import { PayloadActionCreator, createAction } from '@reduxjs/toolkit'
import { call, put, takeEvery } from 'redux-saga/effects'
import { CampaignService, ResponseCampaignToArchive } from '@ads/front-core/api'
import { setArchiveDate } from 'store/reducers/common/setArchiveDateReducer'
import { setCampaignsToArchive } from 'store/reducers/campaign/setCampaignsToArchiveReducer'
import { parseDate } from '@ads/front-core/utils'

const DAYS_TO_ARCHIVE = 3

interface FetchArchiveCampaigns {
  shopId: number
}

type FetchArchiveCampaignsSaga = ReturnType<
  PayloadActionCreator<FetchArchiveCampaigns, string>
>

export function* sagaFetchArchiveCampaigns(): Generator {
  yield takeEvery(fetchArchiveCampaigns.type, fetchArchiveCampaignsSaga)
}

export const fetchArchiveCampaigns = createAction<FetchArchiveCampaigns>(
  'saga/fetchArchiveCampaigns',
)

export function* fetchArchiveCampaignsSaga({
  payload,
}: FetchArchiveCampaignsSaga): Generator {
  const { shopId } = payload

  try {
    const res = yield fetch('/archive')
    const data = yield (res as Response).json()
    if (data?.['dateTo']) {
      yield put(setArchiveDate(parseDate(data['dateTo'])))
    }
  } catch (error) {
    console.error({ error })
  }

  try {
    const res = yield call(CampaignService.getCampaignsToArchive, {
      shopId,
      days: DAYS_TO_ARCHIVE,
    })
    yield put(
      setCampaignsToArchive({
        shopId,
        campaigns: res as ResponseCampaignToArchive[],
      }),
    )
  } catch (error) {
    console.error({ error })
  }
}
